import { SettlementDebt } from "../../../models/Entities/SettlementDebt/SettlementDebt";
import { Settlement } from "../../../models/Entities/Settlements/Settlement";
import { ErrorType } from "../../../models/HttpError";
import { AppState } from "../../../redux/reducers";
import * as jwt_decode from "jwt-decode";

// stores
import * as SettlementStore from '../../../redux/middleware/SettlementMiddleware';
import * as SettlementDebtsStore from '../../../redux/middleware/SettlementDebtsMiddleware';
import * as CashFlowDebtsStore from '../../../redux/middleware/CashFlow-Debts.Middleware';

interface IProps {
    SettlementId: number;
}
  
  interface ConnectedProps {
    // loaading settlment
    isLoading: boolean;
    failOnLoading: boolean;
    isLoadingSuccessfully: boolean;
    errorLoading: ErrorType | undefined;

    // reconfirm settlement
    isChangingSettlementStatus: boolean;
    failOnChangingSettlementStatus: boolean;
    isChangingSettlementStatusSuccessfully: boolean;
    errorChangingSettlementStatus: ErrorType | undefined;
    
    settlement: Settlement | undefined;
    Debts: SettlementDebt[] | undefined;
    /** Ya se pidieron las deudas al menos una vez (con éxito o error). */
    hasLoaded: boolean;
    /** Identificador del centro (tenant): decide si una deuda se cobra o se paga. */
    OwnerId: string;
  }
  
  interface DispatchProps {
    GetSettlementById: typeof SettlementStore.actionCreators.GetSettlementById;
    ResetSettlementChangeStatusFlags: typeof SettlementStore.actionCreators.ResetSettlementChangeStatusFlags;
    GetSettlementDebtsBySettlementId: typeof SettlementDebtsStore.actionCreators.GetSettlementDebtsBySettlementId;
    GetDebtsBySettlementId: typeof CashFlowDebtsStore.actionCreators.GetDebtsBySettlementId;
  }
  
  export type Props = IProps & ConnectedProps & DispatchProps;
  
  export const mapStateToProps = (state: AppState, ownProps: IProps) => {

    const currentSettlement: Settlement | undefined = state.Settlement?.list?.find((item: Settlement) => item.id === ownProps.SettlementId );

    // Las deudas salen sólo de la liquidación. Antes, mientras cargaban, se
    // mostraba la lista global de deudas del tenant (todas, de cualquier
    // liquidación) y después se reemplazaba por las correctas: ese era el salto.
    return {
            isLoading: currentSettlement?.isGettingDebts || false,
            isLoadingSuccessfully: currentSettlement?.isGettingDebtsSuccess || false,
            failOnLoading: currentSettlement?.failOnGettingDebts || false,
            errorLoading: currentSettlement?.ErrorGettingDebts,

            isChangingSettlementStatus: currentSettlement?.isChangingStatus || false,
            isChangingSettlementStatusSuccessfully: currentSettlement?.successChangingStatus || false,
            failOnChangingSettlementStatus: currentSettlement?.failOnChangeStatus || false,
            errorChangingSettlementStatus: currentSettlement?.ErrorChangingStatus,

            settlement: currentSettlement,
            Debts: currentSettlement?.debts,
            hasLoaded: currentSettlement?.isGettingDebtsSuccess !== undefined || !!currentSettlement?.failOnGettingDebts,
            OwnerId: (state?.oidc?.user?.access_token
                ? ((jwt_decode.jwtDecode(state.oidc.user.access_token) as { tenantId?: string })?.tenantId ?? '')
                : ''),
        }
    };
  
  export const mapDispatchToProps = {
    ...SettlementStore.actionCreators,
    ...SettlementDebtsStore.actionCreators,
    ...CashFlowDebtsStore.actionCreators
  };